import et from "date-fns/locale/et";
import ru from "date-fns/locale/ru";
import { getISODay } from "date-fns";
import { registerLocale } from "react-datepicker";
import { t } from "../i18n";

export const getISODateString = (d: Date = new Date()) =>
  (new Date(Number(d) - d.getTimezoneOffset() * 60 * 1000)).toISOString().slice(0, 10);

export type DateIntervalName =
  | "currentMonth"
  | "lastMonth"
  | "lastYear"
  | "monthBeforeLast"
  | "threeMonthsAgo"
  | "today"
  | "totalPeriod"
  | "yearBeforeLast"
  | "yesterday"
  | "currentWeek"
  | "currentYear"
  | "lastTwoMonths"

export type DateInterval = { startDate: Date, endDate: Date };

export type StringFormatDateInterval = { startDate: string, endDate: string }

export type DateIntervals = {
  [key in DateIntervalName]: DateInterval;
};

export const toStringFormatDateInterval = (dateinterval: DateInterval): StringFormatDateInterval => ({
  startDate: getISODateString(dateinterval.startDate),
  endDate: getISODateString(dateinterval.endDate)
})

export const getDateIntervals = (): DateIntervals => {
  const now = new Date();
  const currentFullYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const yesterday = new Date(currentFullYear, currentMonth, now.getDate() - 1);

  return {
    today: { startDate: now, endDate: now },
    yesterday: { startDate: yesterday, endDate: yesterday },
    currentWeek: {
      startDate: new Date(currentFullYear, currentMonth, now.getDate() + 1 - getISODay(now)),
      endDate: new Date(currentFullYear, currentMonth, now.getDate() + 7 - getISODay(now)),
    },
    currentMonth: {
      startDate: new Date(currentFullYear, currentMonth),
      endDate: new Date(currentFullYear, currentMonth + 1, 0),
    },
    lastMonth: {
      startDate: new Date(currentFullYear, currentMonth - 1, 1),
      endDate: new Date(currentFullYear, currentMonth, 0),
    },
    lastTwoMonths: {
      startDate: new Date(currentFullYear, currentMonth - 1, 1),
      endDate: new Date(currentFullYear, currentMonth + 1, 0),
    },
    monthBeforeLast: {
      startDate: new Date(currentFullYear, currentMonth - 2),
      endDate: new Date(currentFullYear, currentMonth - 1, 0),
    },
    threeMonthsAgo: {
      startDate: new Date(currentFullYear, currentMonth - 3),
      endDate: new Date(currentFullYear, currentMonth - 2, 0),
    },
    yearBeforeLast: {
      startDate: new Date(currentFullYear - 2, 0),
      endDate: new Date(currentFullYear - 2, 11, 31),
    },
    currentYear: {
      startDate: new Date(currentFullYear, 0),
      endDate: new Date(currentFullYear, 11, 31),
    },
    lastYear: {
      startDate: new Date(currentFullYear - 1, 0),
      endDate: new Date(currentFullYear - 1, 11, 31),
    },
    totalPeriod: {
      startDate: new Date(0),
      endDate: now,
    }
  }
};

export const registerLocales = () => {
  registerLocale("et", et);
  registerLocale("ru", ru);
}

export const calcSecondsRemaining = (date?: string | null): number => {
  return date ? (new Date(date).getTime() - new Date().getTime()) / 1000 : 0;
}

export const getNextDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);

export const getWeeksPeriod = (count: number): string => {
  const weeks = count === 1 ? "week" : count < 5 ? "weeks" : "weeks_2";
  return t(`investment_market_contracts.for_sell.${weeks}`, { count: count });
};
